import { useEffect, useRef, useState } from 'react';

const LIVE_DURATION_SECONDS = 60 * 60;

export default function useLiveCountdown(sessionId, onExpire) {
    const [seconds, setSeconds] = useState(LIVE_DURATION_SECONDS);
    const deadline = useRef(0);
    const expired = useRef(false);
    const expireRef = useRef(onExpire);

    useEffect(() => {
        expireRef.current = onExpire;
    }, [onExpire]);

    useEffect(() => {
        if (!sessionId) return;

        deadline.current = Date.now() + LIVE_DURATION_SECONDS * 1000;
        expired.current = false;
        setSeconds(LIVE_DURATION_SECONDS);

        const tick = () => {
            if (expired.current) return;

            const remaining = Math.max(
                0,
                Math.ceil((deadline.current - Date.now()) / 1000)
            );

            setSeconds(remaining);

            if (remaining === 0) {
                expired.current = true;
                expireRef.current();
            }
        };

        const timer = window.setInterval(tick, 250);

        document.addEventListener('visibilitychange', tick);

        return () => {
            window.clearInterval(timer);
            document.removeEventListener('visibilitychange', tick);
        };
    }, [sessionId]);

    const continueLive = () => {
        if (
            !sessionId ||
            expired.current ||
            Date.now() >= deadline.current
        ) {
            return;
        }

        deadline.current = Date.now() + LIVE_DURATION_SECONDS * 1000;
        setSeconds(LIVE_DURATION_SECONDS);
    };

    return { seconds, continueLive };
}